var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70703 8.27848C5.17802 8.27848 4.74918 8.70732 4.74918 9.23633C4.74918 9.76534 5.17802 10.1942 5.70703 10.1942V8.27848ZM8.36773 10.1942C8.89674 10.1942 9.32558 9.76534 9.32558 9.23633C9.32558 8.70732 8.89674 8.27848 8.36773 8.27848V10.1942ZM5.70703 10.1942H8.36773V8.27848H5.70703V10.1942Z",
    fill: "#374151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2212 8.27848C13.6922 8.27848 13.2633 8.70732 13.2633 9.23633C13.2633 9.76534 13.6922 10.1942 14.2212 10.1942V8.27848ZM21.139 10.1942C21.668 10.1942 22.0969 9.76534 22.0969 9.23633C22.0969 8.70732 21.668 8.27848 21.139 8.27848V10.1942ZM14.2212 10.1942H21.139V8.27848H14.2212V10.1942Z",
    fill: "#374151"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70703 16.7941C5.17802 16.7941 4.74918 17.2229 4.74918 17.752C4.74918 18.281 5.17802 18.7098 5.70703 18.7098V16.7941ZM13.6891 18.7098C14.2181 18.7098 14.647 18.281 14.647 17.752C14.647 17.2229 14.2181 16.7941 13.6891 16.7941V18.7098ZM5.70703 18.7098H13.6891V16.7941H5.70703V18.7098Z",
    fill: "#141414"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5422 16.7941C19.0132 16.7941 18.5844 17.2229 18.5844 17.752C18.5844 18.281 19.0132 18.7098 19.5422 18.7098V16.7941ZM21.1387 18.7098C21.6677 18.7098 22.0965 18.281 22.0965 17.752C22.0965 17.2229 21.6677 16.7941 21.1387 16.7941V18.7098ZM19.5422 18.7098H21.1387V16.7941H19.5422V18.7098Z",
    fill: "#141414"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6892 9.23643C13.6892 10.5589 12.6171 11.6311 11.2945 11.6311C9.97201 11.6311 8.8999 10.5589 8.8999 9.23643C8.8999 7.91391 9.97201 6.8418 11.2945 6.8418C12.6171 6.8418 13.6892 7.91391 13.6892 9.23643Z",
    stroke: "#141414",
    strokeWidth: 1.9157,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0105 17.7521C19.0105 19.0746 17.9383 20.1467 16.6158 20.1467C15.2933 20.1467 14.2212 19.0746 14.2212 17.7521C14.2212 16.4295 15.2933 15.3574 16.6158 15.3574C17.9383 15.3574 19.0105 16.4295 19.0105 17.7521Z",
    stroke: "#141414",
    strokeWidth: 1.9157,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter_icon.33a1c7c59ab71112e2094162a2435dde.svg";
export { ForwardRef as ReactComponent };